import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { operationalCentersOptions } from "./operationalCentersOptions";

const fieldsQuery = "*.*,bank_transaction.category.*";

export const operationalCentersRoutes = [
    {
        path: "/operational_centers",
        element: (
            <Records
                entity="operational_centers"
                fieldsQuery={fieldsQuery}
                options={operationalCentersOptions}
            />
        ),
    },
    {
        path: "/operational_centers/:id/detail",
        element: (
            <Record
                entity="operational_centers"
                type="detail"
                fieldsQuery={fieldsQuery}
                body={<Groups groupsOptions={operationalCentersOptions.groupsOptions} />}
            />
        ),
    },
    {
        path: "/operational_centers/:id/update",
        element: (
            <Record
                entity="operational_centers"
                type="update"
                fieldsQuery={fieldsQuery}
                body={<EntityForm groupsOptions={operationalCentersOptions.groupsOptions} />}
            />
        ),
    },
    {
        path: "/operational_centers/create",
        element: (
            <Record
                entity="operational_centers"
                type="create"
                fieldsQuery={fieldsQuery}
                body={<EntityForm groupsOptions={operationalCentersOptions.groupsOptions} />}
            />
        ),
    },
];

